import fb from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyB0xfMuqp1AdCTPB8As3Kw-B8vAWL2lu5I',
  authDomain: 'itc-react-blog-site.firebaseapp.com',
  databaseURL: 'https://itc-react-blog-site.firebaseio.com',
  projectId: 'itc-react-blog-site',
  storageBucket: 'itc-react-blog-site.appspot.com',
  messagingSenderId: '308165507477',
  appId: '1:308165507477:web:8c9849bf08c51ab8145e9c',
  measurementId: 'G-KR1TVXV4LE',
};

fb.initializeApp(firebaseConfig);

export const storage = fb.storage();
export const firestore = fb.firestore();
export const auth = fb.auth();
export const provider = new fb.auth.GoogleAuthProvider();
